import {
	RENAME_CREATIVE,
	RENAME_CREATIVE_FILENAME,
	DUPLICATE_CREATIVE,
	DOWNLOAD_CREATIVE,
	DOWNLOAD_CREATIVE_SUMMARY,
	VIEW_ENCODES,
	UPLOAD_CLOSED_CAPTION,
	DELETE_CLOSED_CAPTION,
	RENAME_CONCEPT,
	ADD_SOCIAL_CREATIVE_TO_CONCEPT,
	NEW_ADSTUDIO_CREATIVE_TO_CONCEPT,
	NEW_CREATIVE_TAGS_TO_CONCEPT,
	ADD_EXISTING_CREATIVE_TO_CONCEPT,
	REMOVE_CREATIVE_FROM_CONCEPT,
	DUPLICATE_CONCEPT,
	CLASSIFY,
	PREDICTIVE_SCORING,
	DELETE_CREATIVE,
	DELETE_CONCEPT
} from "./EllipsisActions";

export const ELLIPSIS_ACTION_LIST = [
	[
		RENAME_CREATIVE,
		RENAME_CREATIVE_FILENAME,
		DUPLICATE_CREATIVE,
		DOWNLOAD_CREATIVE,
		DOWNLOAD_CREATIVE_SUMMARY,
	],
	[
		VIEW_ENCODES,
	],
	[
		UPLOAD_CLOSED_CAPTION,
		DELETE_CLOSED_CAPTION,
	],
	[
		RENAME_CONCEPT,
		ADD_SOCIAL_CREATIVE_TO_CONCEPT,
		NEW_ADSTUDIO_CREATIVE_TO_CONCEPT,
		NEW_CREATIVE_TAGS_TO_CONCEPT,
		ADD_EXISTING_CREATIVE_TO_CONCEPT,
		REMOVE_CREATIVE_FROM_CONCEPT,
		DUPLICATE_CONCEPT,
	],
	[
		CLASSIFY,
		PREDICTIVE_SCORING,
	],
	[
		DELETE_CREATIVE,
		DELETE_CONCEPT,
	],
];
